import Loadable from "app/components/Loadable";
import { lazy } from "react";

const AIAssistantListPage = Loadable(lazy(() => import("./AIAssistantListPage")));
const AIAssistantFormPage = Loadable(lazy(() => import("./AIAssistantFormPage")));

const aiAssistantRoutes = [
  { path: "ai-assistants", element: <AIAssistantListPage /> },
  { path: "ai-assistants/:id", element: <AIAssistantFormPage /> },
];

export default aiAssistantRoutes;
